export default {
    list: {
        title: 'Cuentas',
        subtitle: 'Gestionar entidades legales internacionales',
        newAccount: 'Nueva Cuenta',
        loading: 'Cargando cuentas...',
        filters: {
            searchPlaceholder: 'Buscar por nombre, email, ID fiscal...',
            statusPlaceholder: 'Filtrar por estado',
            entityTypePlaceholder: 'Filtrar por tipo',
            countryPlaceholder: 'Filtrar por país',
            userTypePlaceholder: 'Filtrar por tipo de usuario',
            allTypes: 'Todos los tipos',
            allStatuses: 'Todos los estados',
            allCountries: 'Todos los países',
        },
        table: {
            title: 'Cuentas',
            description: 'Lista completa de entidades legales',
            headers: {
                userType: 'Tipo de Usuario',
                legalName: 'Nombre Legal',
                entityType: 'Tipo de Entidad',
                country: 'País',
                status: 'Estado',
                createdAt: 'Fecha de Creación',
                actions: 'Acciones',
            },
            edit: 'Editar',
            noAccounts: {
                title: 'No se encontraron cuentas',
                message: 'Intenta modificar los filtros de búsqueda',
                emptyMessage: 'Comienza creando tu primera cuenta',
                createFirst: 'Crear la primera cuenta',
            },
        },
        status: {
            active: 'Activo',
            suspended: 'Suspendido',
            inactive: 'Inactivo',
        },
        confirmDelete: '¿Estás seguro de que quieres eliminar esta cuenta?',
    },
    form: {
        edit: {
            title: 'Editar Cuenta',
            subtitle: 'Editar detalles de la entidad legal',
        },
        create: {
            title: 'Nueva Cuenta',
            subtitle: 'Crear una nueva entidad legal',
        },
        loading: 'Cargando cuenta...',
        back: 'Atrás',
        sections: {
            general: 'Información General',
            address: 'Dirección',
            contacts: 'Contactos',
            notes: 'Notas Adicionales',
        },
        stepper: {
            step1: {
                title: 'Información de la Empresa',
                description: 'Información básica de la empresa y detalles legales',
            },
            step2: {
                title: 'Detalles Comerciales',
                description: 'Información comercial y preferencias de comercio',
            },
        },
        fields: {
            userType: 'Tipo de Usuario',
            userTypePlaceholder: 'Selecciona el tipo de usuario',
            legalName: 'Nombre Legal',
            legalNamePlaceholder: 'Ingresa el nombre legal',
            entityType: 'Tipo de Entidad',
            entityTypePlaceholder: 'Selecciona el tipo de entidad',
            taxId: 'ID Fiscal / Número IVA',
            taxIdPlaceholder: 'Ingresa ID fiscal o número IVA',
            status: 'Estado',
            statusPlaceholder: 'Selecciona el estado',
            street: 'Calle',
            streetPlaceholder: 'Ingresa la dirección completa',
            city: 'Ciudad',
            cityPlaceholder: 'Ingresa la ciudad',
            state: 'Estado/Provincia',
            statePlaceholder: 'Ingresa estado o provincia',
            postalCode: 'Código Postal',
            postalCodePlaceholder: 'Ingresa el código postal',
            country: 'País',
            countryPlaceholder: 'Selecciona el país',
            email: 'Email',
            emailPlaceholder: 'nombre@empresa.com',
            phone: 'Teléfono',
            phonePlaceholder: '+1 555 123 4567',
            notes: 'Notas',
            notesPlaceholder: 'Ingresa notas adicionales sobre la cuenta...',
            // Campos Trade Details
            commodityType: 'Tipo de Mercancía',
            commodityTypePlaceholder: 'Selecciona el tipo de mercancía',
            commodityTypeOptions: {
                fresh: {
                    label: 'Productos Frescos',
                    description: 'Frutas, verduras, etc.',
                },
                soft: {
                    label: 'Mercancías Blandas',
                    description: 'Café, cacao, azúcar, etc.',
                },
                hard: {
                    label: 'Mercancías Duras',
                    description: 'Metales, energía, etc.',
                },
            },
            specificProducts: 'Productos Específicos',
            specificProductsPlaceholder: 'Ingresa productos específicos (opcional)',
            mainOrigins: 'Orígenes Principales/Países de Origen',
            mainOriginsPlaceholder: 'Selecciona países de origen',
            mainDestinations: 'Destinos Principales/Mercados',
            mainDestinationsPlaceholder: 'Selecciona países de destino',
            monthlyContainerVolume: 'Volumen Mensual de Contenedores',
            monthlyContainerVolumePlaceholder: 'Ingresa volumen mensual',
        },
        actions: {
            cancel: 'Cancelar',
            save: 'Guardar Cambios',
            create: 'Crear Cuenta',
            next: 'Siguiente',
            back: 'Atrás',
            previous: 'Anterior',
        },
    },
};

